export type AssetBundleSortKey = 'brand' | 'modelYear';

export interface AssetBundleRow {
	readonly id: string;
	readonly title: string;
	readonly brand: string;
	readonly modelYear: number | string;
	readonly modelYearValue: number | null;
}

export const compareAssetBundles = (a: AssetBundleRow, b: AssetBundleRow, key: AssetBundleSortKey): number => {
	if (key === 'brand') {
		const brandA = a.brand === '—' ? null : a.brand;
		const brandB = b.brand === '—' ? null : b.brand;

		if (brandA && brandB) {
			return brandA.localeCompare(brandB, undefined, { sensitivity: 'base' });
		}

		if (brandA) {
			return -1;
		}

		if (brandB) {
			return 1;
		}

		return 0;
	}

	const yearA = a.modelYearValue;
	const yearB = b.modelYearValue;

	if (typeof yearA === 'number' && typeof yearB === 'number') {
		return yearA - yearB;
	}

	if (typeof yearA === 'number') {
		return -1;
	}

	if (typeof yearB === 'number') {
		return 1;
	}

	return 0;
};
